// /src/pages/AdminPage.js
// Hub for administrative tools. These used to sit in the sidebar, which meant
// an admin's sidebar looked nothing like a user's. Collecting them here keeps
// the sidebar identical for both roles, so what you demo is what they get.
import React from "react";
import { Link } from "react-router-dom";
import {
  FaUsers, FaSitemap, FaThLarge, FaCalendarAlt, FaClipboardList, FaFileAlt, FaChartLine,
  FaUserShield, FaCar,
} from "react-icons/fa";

const TOOLS = [
  {
    to: "/users",
    icon: FaUsers,
    title: "Manage Users",
    blurb: "Accounts, roles, department assignment, and per-user module access.",
  },
  {
    to: "/access-control",
    icon: FaUserShield,
    title: "Ask & Answer Access",
    blurb: "Which data (subject areas / tables) each department and role may query.",
  },
  {
    to: "/departments",
    icon: FaSitemap,
    title: "Manage Departments",
    blurb: "Departments and the modules their members inherit.",
  },
  {
    to: "/modules",
    icon: FaThLarge,
    title: "Modules",
    blurb: "Which modules this deployment has licensed, and how they are ordered.",
  },
  {
    to: "/dashboards/admin",
    icon: FaChartLine,
    title: "Dashboards",
    blurb: "Per-dashboard cards, time ranges, and layout for every dashboard.",
  },
  {
    to: "/titleagent/admin",
    icon: FaCar,
    title: "Title Agent",
    blurb: "Yard detail, and which sites may raise or receive a TR-9 transfer.",
  },
  {
    to: "/holidays",
    icon: FaCalendarAlt,
    title: "Manage Holidays",
    blurb: "Observed holidays used by report scheduling.",
  },
  {
    to: "/scheduled-reports",
    icon: FaFileAlt,
    title: "Scheduled Reports",
    blurb: "Every user's scheduled reports, not just your own.",
  },
  {
    to: "/audit",
    icon: FaClipboardList,
    title: "Audit Log",
    blurb: "Append-only record of chat activity and access-control changes.",
  },
];

export default function AdminPage() {
  return (
    <div style={{ padding: "16px" }}>
      <h2>Administration</h2>
      <p style={{ opacity: 0.75, marginTop: -6 }}>
        Tools visible only to administrators.
      </p>

      <div style={grid}>
        {TOOLS.map(({ to, icon: Icon, title, blurb }) => (
          <Link key={to} to={to} style={card} className="admin-card">
            <div style={cardHead}>
              <Icon aria-hidden style={{ fontSize: 20, color: "#8ab4ff" }} />
              <span style={{ fontWeight: 600 }}>{title}</span>
            </div>
            <div style={{ opacity: 0.75, fontSize: 14 }}>{blurb}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
  gap: 14,
  marginTop: 14,
};

const card = {
  display: "block",
  padding: "16px",
  borderRadius: 12,
  border: "1px solid #26324f",
  background: "linear-gradient(180deg, rgba(15,23,42,.75), rgba(12,19,38,.9))",
  color: "#e6eefc",
  textDecoration: "none",
};

const cardHead = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  marginBottom: 8,
};
